import { LastTermDistribution } from "../lastTermDistribution.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";


export class LastTermDistributionSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new LastTermDistribution();
        this._copyAttributes(gp, data);
        return gp;

    }

}
